import {post} from '@/utils/request';
import {erpserver,oaserver,erpplatserver} from '@/utils/baseUrl';

//shenhe
export async function cancel(params) {
    return post(erpserver+'/purchaseinvoice/cancel', params, true);
}
// 保存核销
export async function getPurchaseInTransitList(params) {
    return post(erpserver+'/purchaseinvoice/getPurchaseInTransitList', params, true);
}
// 保存核销
export async function writeoffInvoiceInTransit(params) {
    return post(erpserver+'/purchaseinvoice/writeOffInvoiceInTransit', params, true);
}
// 在途发票
export async function getInvoiceInTransitList(params) {
    return post(erpserver+'/purchaseinvoice/getInvoiceInTransitList', params, true);
}
// 验证发票池
export async function syncState(params) {
    return post(erpserver+'/purchaseinvoice/syncState', params, true);
}
// 多出关联量转在途
export async function closeToZt(params) {
    return post(erpserver+'/purchaseinvoice/closeToZt', params, true);
}
// 终止入库申请
export async function closeSq(params) {
    return post(erpserver+'/purchaseinvoice/closeSq', params, true);
}
// 查询关闭订单预览
export async function closePreview(params) {
    return post(erpserver+'/purchaseinvoice/closePreview', params, true);
}
// 查询当前是否可关闭订单
export async function closeState(params) {
    return post(erpserver+'/purchaseinvoice/closeState', params, true);
}

// 查询关联付款申请
export async function getGlFksq(params) {
    return post(erpserver+'/purchaseinvoice/getGlFksq', params, true);
}
// 查询关联订单
export async function getGlOrder(params) {
    return post(erpserver+'/purchaseinvoice/getGlOrder', params, true);
}
// 查询付款申请
export async function fksq(params) {
    return post(erpserver+'/purchaseinvoice/fksq', params, true);
}
// 查询费用
export async function getFees(params) {
    return post(erpserver+'/purchaseinvoice/getFees', params, true);
}

//关闭订单
export async function closeOrder(params) {
    return post(erpserver+'/purchaseinvoice/closeOrder',params,true);
}
//上传图片-new
export async function uploadInvoice(params) {
    return post(erpplatserver+'/system/uploadInvoice',params,false);
}
//上传图片
export async function upload(params) {
    return post(erpplatserver+'/system/uploadFile',params,false);
}
//根据开票方获取发票编号列表-获取详情
export async function beforedetail(params) {
    return post(erpserver+'/purchaseinvoice/beforedetail', params, true);
}
//根据开票方获取发票编号列表
export async function beforehandle(params) {
    return post(erpserver+'/purchaseinvoice/beforehandle', params, true);
}
//发票类型
export async function fplx(params) {
    return post(erpserver+'/purchaseinvoice/fplx', params, true);
}
//详情
export async function detail(params) {
    return post(erpserver+'/purchaseinvoice/detail', params, true);
}
//品种
export async function pzlist(params) {
    return post(erpserver+'/purchaseinvoice/pzlist', params, true);
}
//销售方
export async function getKhByKz(params) {
    return post(erpserver+'/purchaseinvoice/getKhByKz', params, true);
}
//保存
export async function save(params) {
    return post(erpserver+'/purchaseinvoice/save', params, true);
}
//查询发票list
export async function list(params) {
    return post(erpserver+'/purchaseinvoice/list', params, true);
}
//查询开票类型
export async function fptype(params) {
    return post(erpserver+'/purchaseinvoice/fptype', params, true);
}
//查询开票方（客户
export async function getkhlist(params) {
    //return post(erpserver+'/purchaseinvoice/getkhlist', params, true);
    //return post(erpserver+'/currency/getkhlist', params, true);
    return post(erpserver+'/currency/getkhlistWithRights', params, true);
}
// 获取公司
export async function getCompanyList(params) {
    //return post(erpserver+'/purchaseinvoice/getgslist', params, true);
    return post(erpserver+'/currency/getCompanyList', params, true);
}
// 查询订单
export async function getOrders(params) {
    return post(erpserver+'/purchaseinvoice/getOrders', params, true);
}
// 查询订单
export async function getOrderList(params) {
    return post(erpserver+'/purchaseinvoice/getOrderList', params, true);
}
export async function getRedInvoiceDetail(params) {
    return post(erpserver+'/purchaseinvoice/getRedInvoiceDetail', params, true);
}
export async function getRebateInvoiceGoods(params) {
    return post(erpserver+'/purchaseinvoice/getRebateInvoiceGoods', params, true);
}
// 品名匹配
export async function convertUnit(params) {
    return post(erpserver+'/purchaseinvoice/convertUnit', params, true);
}
// 单位换算
export async function convertUnitNew(params) {
    return post(erpserver+'/purchaseinvoice/convertUnitNew', params, true);
}
//
export async function getbzlist(params) {
    return post(erpserver+'/currency/getbzlist', params, true);
}
//submit
export async function submit(params) {
    return post(erpserver+'/purchaseinvoice/commit', params, true);
}
//refresh
export async function refresh(params) {
    return post(erpserver+'/purchaseinvoice/refresh', params, true);
}
//上传发票池
export async function saveToPool(params) {
    return post(erpserver+'/purchaseinvoice/saveToPool', params, true);
}
//进项发票作废
export async function disableInvoice(params) {
    return post(erpserver+'/purchaseinvoice/disableInvoice', params, true);
}
